import { from, Subject } from 'rxjs';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AfterViewInit, Component, Input, LOCALE_ID, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { APIService } from '../../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-stores',
  templateUrl: './stores.component.html',
  styleUrls: ['./stores.component.scss']
})
export class StoresComponent implements OnInit, AfterViewInit {
  changingValue: Subject<boolean> = new Subject();
  constructor(private modalService: NgbModal, private apiService: APIService, private router: Router, private http: HttpClient, private route: ActivatedRoute) { }

  jarvis: any = []
  user: any = [];
  jarvisData: any = [];
  userData: any = [];
  editRights: any = [];
  rights: any = [];
  UIDs: any = [];
  stores: any = [];
  agencyData: any = [];
  GSTMultiLocation: any = [];
  MultiGSTList: any = [];
  selGSTLoc: any;
  ISEGST: any = false;
  editStoreId: number = 0
  oldStoreName: string = ''
  oldLID : any = 0;

  data: any = {
    sNm: '',
    StrID: 0,
    UIDs: [],
    LID: 0,
    isJobStore: false,
    relID: 0
  }
  newStore = {
    Name: ''
  }
  editStoreName = {
    Name: ''
  }
  suppliers: any = [];
  connections: any = [];
  cntMaxStores: number = 300;

  @Input() mdlRef: any;
  modalshow: boolean = false;
  @ViewChild('mymodal') addModalRef!: TemplateRef<any>;
  showOnlyAddModal: boolean = false;

  ngOnInit(): void {

    if (this.mdlRef) {
      this.modalshow = true;
    }
    var jarvis = this.apiService.getCookie("Jarvis");

    let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      this.ISEGST = this.agencyData[0].EGST
      this.GSTMultiLocation = this.agencyData[0].Locations
      this.MultiGSTList = JSON.parse(this.GSTMultiLocation);
      this.MultiGSTList = this.MultiGSTList.filter((o: any) => o.IsD == false);
    }

    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    var user = this.apiService.getCookie("J");
    if (user) {
      this.userData = JSON.parse(user);
    }

    this.getRigths();
    this.getStore();
    // Get Relatives - Indexed DB
    this.getHRels();
    
   // this.selectGSTLocation()

  }

  ngAfterViewInit(): void {
    if (this.mdlRef) {
      this.open(this.addModalRef, 0);
    }
    
    this.route.queryParams.subscribe(params => {
      if (params['o'] == '1') {
        setTimeout(() => {
          this.open(this.addModalRef, 0);
        }, 100);
      }
    });
  }

  //getStore() - get all store
  getStore() {
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'getConfig',
      moduleID: 6,
      data: ''
    }];
    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this));
  }

  //successResp - success  get handler
  successResp(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table2) {
          let editDataArry = JSON.parse(reponseData.Table2[0].Stores);
          // editDataArry.forEach((p: any) => {
          //   let LocData = element.StoreBatches.filter((a: any) => { return a.SID == this.store.id });

          //   let LocData = this.MultiGSTList.filter((x: any) => x.ID == p.LID);
          //   p.LocatonName = LocData.SNm;
          // })
          var adminData = this.userData.filter((element: any) => element.UserID == this.agencyData[0].AdminUserID);

          for (let j = 0; j < editDataArry.length; j++) {
            let TempUIDs: any = [];
            let IDs = editDataArry[j].UIDs == undefined ? '' : (editDataArry[j].UIDs).split(",")
            if (IDs != '') {
              for (let i = 0; i < IDs.length; i++) {
                var IDsData = this.userData.filter(function (element: any, index: any) {
                  return (element.UserID == IDs[i]);
                });
                if (IDsData.length > 0) {
                  let temp = {
                    UserID: IDs[i],
                    Name: IDsData[0].Name
                  }
                  TempUIDs.push(temp)
                }
              }
            } else {
              if (adminData.length > 0) {
              let temp = {
                UserID: this.agencyData[0].AdminUserID,
                Name: adminData[0].Name
              }
              TempUIDs.push(temp);
              }
            }
            this.stores.push({
              'StrID': editDataArry[j].StrID,
              'sNm': editDataArry[j].sNm,
              'UIDs': TempUIDs.length == 0 ? [] : TempUIDs,
              'LID': editDataArry[j].LID,
              'IsJobStr' : editDataArry[j].IsJobStr ? editDataArry[j].IsJobStr : false,
              'RID' : editDataArry[j].IsJobStr ? (editDataArry[j].RID ? editDataArry[j].RID : 0) : 0
            });
          }
        }
      }

      this.stores = this.stores.sort((a: any, b: any) => a.sNm.localeCompare(b.sNm));
    }
  }

  //getRigths() - get all users
  getRigths() {
    this.rights = [];
    for (let i = 0; i < this.userData.length; i++) {
      if (this.jarvisData[0].UserID == this.userData[i].UserID || this.userData[i].UserID == this.agencyData[0].AdminUserID){
        let temp = {
          UserID: this.userData[i].UserID,
          Name: this.userData[i].Name,
          isChecked: true,
          IsDisabled: true
        }
        this.rights.push(temp);
      }
      else {
        let temp = {
          UserID: this.userData[i].UserID,
          Name: this.userData[i].Name,
          isChecked: false,
          IsDisabled: false
        }
        this.rights.push(temp);
      }

    }
  }

  closeResult: any;
  modalReference: any;

  getHRels () {
    //Get H from IDB
    var self = this;
    var tblH = this.apiService.getIDB('H', function(dataList: any){
      if(dataList){ 
        self.connections = dataList;
        self.suppliers = $.grep(self.connections, (e: any) => { return (e.S == true) });      
      }
    })
  }


  //open() - open add and edit store modal
  open(content: any, id: number) {
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'my-class', backdrop: 'static', keyboard: false });
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    },
      (reason: any) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
      this.data.LID = 0;
      this.data.isJobStore = false;
      this.data.relID = 0;
      this.editStoreId = id;
    if (id != 0) {
      let StoreData = this.stores.filter(function (element: any, index: any) {
        return (element.StrID == id);
      });
      this.oldStoreName = StoreData[0].sNm;      
      this.data.LID = StoreData[0].LID;
      this.data.isJobStore = StoreData[0].IsJobStr ? true : false;
      this.data.relID = StoreData[0].IsJobStr && StoreData[0].RID ? StoreData[0].RID : 0;
	  this.fn_editRights(id);
    }
  }

  fn_editRights = (id: any) => {
      let StoreData = this.stores.filter(function (element: any, index: any) {
        return (element.StrID == id);
      });
      this.editRights = [];

      let storeUserLength = StoreData[0].UIDs == undefined ? 0 : StoreData[0].UIDs.length;

      for (let j = 0; j < this.rights.length; j++) {
        if (storeUserLength > 0) {
          let storeUser = StoreData[0].UIDs.filter((x: any) => x.UserID == this.rights[j].UserID);

          let temp: any = {};
          if (storeUser.length > 0 || this.rights[j].UserID == this.agencyData[0].AdminUserID) {
            temp = {
              UserID: this.rights[j].UserID,
              Name: this.rights[j].Name,
              isChecked: true,
              IsDisabled: this.rights[j].IsDisabled
            }
          }
          else {
            temp = {
              UserID: this.rights[j].UserID,
              Name: this.rights[j].Name,
              isChecked: false,
              IsDisabled: this.rights[j].IsDisabled
            }
          }
          this.editRights.push(temp);
        }
        else {
          this.editRights = this.rights;
        }
      }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  closeModelStore() {
    let doneObj = {
      action: 'Done',
      obj: null
    }
    this.mdlRef.close(doneObj);
  }

  public closeModal($event: any) {
    this.modalReference.close();
    // this.MultiGSTList = [];
    this.getRigths();
    if(this.showOnlyAddModal) {
      this.closeModelStore();
    }
    if ($event) {
      this.changingValue.next($event);
    }
  }

  //addStore() - add new store
  addStore(name: string, obj: any) {
    let storeName = name;
    if (name == '') {
      this.apiService.successAlert("Please enter store name.")
      return;
    }
    if (this.data.isJobStore && !this.data.relID) {
      this.apiService.successAlert("Please select Supplier.")
      return;
    }
    for (let i = 0; i < obj.length; i++) {
      if (obj[i].isChecked == true) {
        let temp = {
          UserID: obj[i].UserID,
          Name: obj[i].Name
        }
        this.UIDs.push(temp)
      }
    }
    let maxStrID = Math.max(...this.stores.map((store : any) => store.StrID), 0);
    var tempData : any = [];
    tempData = {
      'StrID': maxStrID + 1,
      'sNm': this.data.sNm,
      'UIDs': this.UIDs,
      'LID': (this.ISEGST ? this.data.LID : 1),
      'IsJobStr' : this.data.isJobStore ? this.data.isJobStore : false,
      'RID' : this.data.isJobStore ? (this.data.relID ? this.data.relID : 0) : 0
    }

    let flag = false;
    if (this.stores.length >= this.cntMaxStores) {
      this.apiService.successAlert("You can only add up to " + this.cntMaxStores + " stores.");
      this.newStore.Name = '';
      return;
    }
    else {
      for (let i = 0; i < this.stores.length; i++) {
        if (storeName.toUpperCase() == this.stores[i].sNm.toUpperCase()) {
          flag = true
          break
        }
      }
    }

    if (!flag) {
      this.stores.push(tempData)
      this.data.sNm = '';
      this.data.isJobStore = false;
      this.data.relID = 0;
      this.save();
      this.modalReference.close();

      this.getRigths();
    }
    else {
      this.apiService.successAlert("This store already exists.")
      this.data.sNm = '';
      this.data.isJobStore = false;
      this.data.relID = 0;
      return;
    }
   // this.selectGSTLocation()
    this.UIDs = []

  }

  //save() - save store
  save() {
    let TempStore: any = [];
    for (let i = 0; i < this.stores.length; i++) {
      let newId = [];
      if (this.stores[i].UIDs.length != 0) {
        for (let j = 0; j < this.stores[i].UIDs.length; j++) {
          newId.push(this.stores[i].UIDs[j].UserID)
        }

      }
      TempStore.push({
        'StrID': this.stores[i].StrID,
        'sNm': this.stores[i].sNm,
        'UIDs': this.stores[i].UIDs.length == 0 ? '' : newId.join(","),
        'LID': this.stores[i].LID,
        'IsJobStr' : this.stores[i].IsJobStr ? this.stores[i].IsJobStr : false,
        'RID' : this.stores[i].IsJobStr ? (this.stores[i].RID ? this.stores[i].RID : 0) : 0
      });
    }
    var tempData = [{
      'ChangeType': 'STRS',
      'GSTLdgrs': '',
      'Units': '',
      'Stores': JSON.stringify(TempStore),
      'ItemCategories': '',
      'PrdJobStages': '',
      'ValnMethod': 1,
      'PrdRejnReasons': '',
      'HSNSAC': '',
    }]
    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      myLastSyncDT: null,
      isWeb: true,
      actionType: 'set',
      moduleID: 6,
      data: JSON.stringify(tempData)
    }];
    this.apiService.sendChange(myParams, this.successEntry.bind(this), this.failureResp.bind(this));
  }

  //successVchrEntry - success store entry handler
  successEntry(res: any) {
    if (res.error) {
    }
    else {
      if (res) {
        var ErpData = JSON.parse(res.updatePackage);
        if (ErpData.Table1) {
          let coockieData = [];
          coockieData.push(ErpData.Table1[0]);
          let ErpAgn = JSON.stringify(coockieData);
          localStorage.setItem("ERP_Agn", ErpAgn)
        }
        if (ErpData.Table2) {
          let cookieData2 = [];
          cookieData2.push(ErpData.Table2[0]);
          let ErpCfgData = JSON.stringify(cookieData2);
          localStorage.setItem("ERP_Cfg", ErpCfgData)
        }
      }
      this.stores = []
      this.getStore();
   //   this.selectGSTLocation()
      this.modalReference.close();
      this.closeModelStore();
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //editStore() - edit store
  editStore(name: any, obj: any) {
    let oldName = this.oldStoreName

    let ind = this.editStoreId
    var StoreData = this.stores.filter(function (element: any, index: any) {
      return (element.StrID == ind);
    });
    // let oldLID = StoreData[0].LID
    if (this.data.isJobStore && !this.data.relID) {
      this.apiService.successAlert("Please select Supplier.")
      return;
    }

    let Right: any = []
    for (let i = 0; i < obj.length; i++) {
      if (obj[i].isChecked == true) {
        let temp = {
          UserID: obj[i].UserID,
          Name: obj[i].Name
          //isChecked:obj[i].isChecked,
        }
        Right.push(temp);
      }
    }
    let tempStore : any = []
    tempStore = {
      'sNm': name,
      'StrID': ind,
      'UIDs': Right,
      'LID': this.data.LID,
      'IsJobStr' : this.data.isJobStore ? this.data.isJobStore : false,
      'RID' : this.data.isJobStore ? (this.data.relID ? this.data.relID : 0) : 0
    }
    let flag = false
    if (name == '') {
      flag = true
      this.oldStoreName = StoreData[0].sNm;
      this.apiService.successAlert("Please enter store name.")
      return
    }
    for (let i = 0; i < this.stores.length; i++) {
      if (name == this.stores[i].sNm) {
        flag = true
        break
      }
    }
    if (oldName.toUpperCase() == StoreData[0].sNm.toUpperCase()) {
      flag = false
    }

    if (!flag) {
      for (let i = 0; i < this.stores.length; i++) {
        if (this.stores[i].StrID == StoreData[0].StrID) {
          this.stores[i].sNm = tempStore.sNm;
          this.stores[i].UIDs = Right;
          this.stores[i].LID = tempStore.LID;
          this.stores[i].IsJobStr = tempStore.IsJobStr ? tempStore.IsJobStr : false;
          this.stores[i].RID = tempStore.IsJobStr ? (tempStore.RID ? tempStore.RID : 0) : 0
        }
      }
      this.save();
      this.modalReference.close();
    }
    else {
      this.oldStoreName = StoreData[0].sNm
      this.apiService.successAlert("Please enter valid store name.")
    }

  }

  // color change 
  changeColor(ind: any){
    var clr = ""
    switch(ind) { 

      case 0: { 
        clr = 'orangeBadge'
         break; 
      } 
      case 1: {
        clr = 'yellowBadge'
        break; 
      } 
      case 2: { 
        clr = 'greenBadge'
         break; 
      } 
      case 3: { 
        clr = 'tealBadge'
         break; 
      } 
      case 4: { 
        clr = 'blueBadge'
         break; 
      } 
      case 5: { 
        clr = 'darkBlueBadge'
         break; 
      } 
      case 6: { 
        clr = 'brownBadge'
         break; 
      } 
    
   }
   return clr; 
  }


  // back() - back to page
  back() {
    this.router.navigate(['Settings']);
  }

  backBtn() {
    window.history.back();
  }

  closeModel() {
    let doneObj = {
      action: 'Done',
      obj: null
    }
    this.mdlRef.close(doneObj);
    // this.activeModal.dismiss();
  }

  changeGSTLoc() {
    let tblJ = this.apiService.getCookie("J");
    if(tblJ){
      this.userData = JSON.parse(tblJ);
      if(this.data.LID > 0){
        this.userData = this.userData.filter((o: any) => o.LocID == 0 || o.LocID == this.data.LID); 
      }     
      this.getRigths();
      if(this.editStoreId > 0){
        this.fn_editRights(this.editStoreId);        
      }      
    }
  }
}
